import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { SessionProvider } from "./context/SessionContext";
import Landing from "./pages/Landing";
import DashboardLayout from "./pages/DashboardLayout";
import Overview from "./pages/Overview";
import Sales from "./pages/Sales";
import Inventory from "./pages/Inventory";
import Procurement from "./pages/Procurement";
import HR from "./pages/HR";
import Analytics from "./pages/Analytics";
import Ask from "./pages/Ask";

function App() {
  return (
    <div className="App">
      <SessionProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/app" element={<DashboardLayout />}>
              <Route index element={<Navigate to="/app/overview" replace />} />
              <Route path="overview" element={<Overview />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="sales" element={<Sales />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="procurement" element={<Procurement />} />
              <Route path="hr" element={<HR />} />
              <Route path="ask" element={<Ask />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SessionProvider>
    </div>
  );
}

export default App;
